import styled, { css } from 'styled-components/macro'
import { layout, space } from 'styled-system'
import { ColorsMap } from '@/utils/Theme'

export const Wrapper = styled.div``

type StyledInputProps = { invalid: boolean }
export const StyledInput = styled.textarea<StyledInputProps>`
  outline: none;
  width: 100%;
  border: 1px solid ${ColorsMap.textDefault};
  min-height: 8rem;
  border-radius: 1.2rem;
  padding: 1rem 1.5rem;
  appearance: none;
  resize: none;
  color: ${ColorsMap.black};

  ${({ invalid }) =>
    invalid &&
    css`
      border-color: ${ColorsMap.error};
    `}
  ${layout}
  ${space}
`

export const Label = styled.label`
  margin: 1rem 0;
`
